import head from "lodash/head";
import orderBy from "lodash/orderBy";
import { all, call, put, select, spawn, takeLatest } from "redux-saga/effects";
import { endFlow, startFlow } from "student-front-commons/src/actions/flow";
import { startExecution } from "student-front-commons/src/actions/execution";
import { addEntity } from "student-front-commons/src/actions/entity";
import { getFlow, getFlowStart } from "student-front-commons/src/selectors/flow";
import { getEntityById } from "student-front-commons/src/selectors/entity";
import { addImageDataToItems, addSoundToItems, logError } from "../util";
import browserHistory from "../browserHistory";
import {
  DETECT_DEV_TOOLS_FLOW,
  GET_NEXT_UNIT_ITEM_EXECUTION_FLOW,
  LOAD_CONFIGURATION_FLOW,
  START_HOMEWORK_EXECUTION_FLOW,
  USER_AWAY_TIMEOUT_FLOW,
  USER_LAST_ACTION_FLOW,
} from "../consts";
import { showMessage } from "student-front-commons/src/actions/systemMessage";
import { startHomeworkExecution } from "student-front-commons/src/services/homeworkService";

export default function* () {
  yield takeLatest(getFlowStart(START_HOMEWORK_EXECUTION_FLOW), function* () {
    const flow = yield select(getFlow(START_HOMEWORK_EXECUTION_FLOW));
    try {
      const configurations = yield select((state) => state.configurations.id);
      if (!configurations) {
        yield put(startFlow(LOAD_CONFIGURATION_FLOW));
      }

      const result = yield call(startHomeworkExecution, {
        homework: flow.params.homework,
        unit: flow.params.unit,
      });

      const orderedItems = orderBy(result.items, ["order"], ["asc"]);

      yield all([
        ...addImageDataToItems(
          orderedItems.slice(
            (result.unitExecution.answers || []).length,
            (result.unitExecution.answers || []).length + 3
          )
        ),
        ...addSoundToItems(
          orderedItems.slice(
            (result.unitExecution.answers || []).length,
            (result.unitExecution.answers || []).length + 3
          )
        ),
      ]);

      yield put(
        startExecution({
          ...result.unitExecution,
          items: result.items,
          module: flow.params.module,
          unit: flow.params.unit,
          homework: flow.params.homework,
        })
      );

      yield spawn(function* () {
        yield all([
          ...addImageDataToItems(orderedItems.slice((result.unitExecution.answers || []).length + 3)),
          ...addSoundToItems(orderedItems.slice((result.unitExecution.answers || []).length + 3)),
        ]);
      });

      const unit = yield select(getEntityById("unit", flow.params.unit));
      yield put(
        addEntity("unit", {
          ...unit,
          lastExecutionStartedAt: result.unitExecution.startedAt,
          lastExecutionStudiedTime: 0,
        })
      );

      yield put(startFlow(DETECT_DEV_TOOLS_FLOW));
      yield put(startFlow(GET_NEXT_UNIT_ITEM_EXECUTION_FLOW));
      yield put(startFlow(USER_LAST_ACTION_FLOW));
    } catch (error) {
      yield put(endFlow(USER_AWAY_TIMEOUT_FLOW));
      if (error.code === "three_minute_block") {
        yield put(
          showMessage({
            message: "error.three_minute_block",
            icon: "lock-outline",
          })
        );
        yield call(browserHistory.replace, `${head(window.location.pathname.split("/units"))}/units`);
      } else {
        logError({ error, location: "start-homework-execution" });
        yield call(browserHistory.replace, "/exercise-not-found");
      }
    } finally {
      yield put(endFlow(START_HOMEWORK_EXECUTION_FLOW));
    }
  });
}
